import { MoovStepDefinitionDTO } from "../DTO/moovStepDefinitionDTO";

export class MoovStepDefinition{

    public id!:number;
    public name!:string;
    public description!:string;
    public stepType!:string;
    public parameterOptions?:ParameterOption[];
    public allowedPredecessors!:string[];
    public skipAllowed!:boolean;
    public approvalRequired!:boolean;
    public scopeRestrictions?: string[];
    public premierPartnerRestriction?: number;
    public canUndo?:boolean;

    contructor(){
        
    }
 
    public static mapFromDTO(param:MoovStepDefinitionDTO):MoovStepDefinition{ 
        if (!param) throw new Error("parameter is null")
        let obj = new MoovStepDefinition();
        try
        {
            obj.id = param.id;
            obj.name = param.name;
            obj.description = param.description;
            obj.stepType = param.stepType;
            if(param.parameters?.length>0){
                obj.parameterOptions=[];
                var jsonObjArray = JSON.parse(param.parameters);
                for(let jsonObj of jsonObjArray){
                    obj.parameterOptions.push(new ParameterOption(jsonObj))
                }
            }
            obj.allowedPredecessors = JSON.parse(param.allowedPredecessors);
            obj.skipAllowed = param.skipAllowed;
            obj.approvalRequired = param.approvalRequired;
            if(param.scopeRestrictions && param.scopeRestrictions.length>0) obj.scopeRestrictions = param.scopeRestrictions.split(',');
            obj.premierPartnerRestriction=param.premierPartnerRestriction;
            obj.canUndo=param.canUndo;
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }

    public static mapToDTO(param:MoovStepDefinition):MoovStepDefinitionDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new MoovStepDefinitionDTO();
        try
        {
            dto.id = param.id;
            dto.name = param.name;
            dto.description = param.description;
            dto.stepType = param.stepType;
            if(param.parameterOptions && param.parameterOptions.length>0) dto.parameters = JSON.stringify(param.parameterOptions, (key, value) => {return (key=="inputOptionArray")?undefined:value;}); //don't serialize inputOptionArray
            if(param.allowedPredecessors && param.allowedPredecessors.length>0) dto.allowedPredecessors = JSON.stringify(param.allowedPredecessors);
            dto.skipAllowed = param.skipAllowed;
            dto.approvalRequired = param.approvalRequired;
            if(param.scopeRestrictions && param.scopeRestrictions.length>0) dto.scopeRestrictions = param.scopeRestrictions.join(',');
            param.premierPartnerRestriction = dto.premierPartnerRestriction;
            param.canUndo = dto.canUndo;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }

    get isTriggerStep(){
        return (this.stepType=='tr' || this.stepType=='qi' || this.stepType=='dt' || this.stepType=='elpdat' || this.stepType=='elpdoc' || this.stepType=='st' || this.stepType=='pedt' || this.stepType=='ppdt' || this.stepType=='wh');
    }

    get isDataTriggerStep(){
        return (this.stepType=='tr' || this.stepType=='qi' || this.stepType=='elpdat' || this.stepType=='st' || this.stepType=='pedt' || this.stepType=='ppdt' || this.stepType=='wh');
    }

    get isDocumentTriggerStep(){
        return (this.stepType=='dt' || this.stepType=='elpdoc');
    }

    get isWebhookTriggerStep(){
        return (this.stepType=='wh');
    }


    get isEditStep(){
        return (this.stepType=='ed');
    }

    get isQBOStep(){
        return this.stepType=='iq' || this.stepType=='qi';
    }

    get isTransformationStep(){
        return this.stepType=='tf';
    }

    get isResetDataStep(){
        return this.stepType=='rd';
    }

    get isApplyFileDefinitionStep(){
        return this.stepType=='af';
    }

    get needsQBOAuthorization(){
        return this.stepType=='iq';
    }

    get isXeroStep(){
        return this.stepType=='xi';
    }

    get needsXeroAuthorization(){
        return this.stepType=='xi';
    }

    get isDropboxStep(){
        return this.stepType=='du';
    }

    get needsDropboxAuthorization(){
        return this.stepType=='du';
    }

    get isMicrosoftStep(){
        return this.stepType=='msc';
    }

    get needsMicrosoftAuthorization(){
        return this.stepType=='msc';
    }

    get isAIStep(){
        return this.stepType=='ai';
    }

}

export class ParameterOption{
    id!: number;
    label!: string;
    parameters!: Parameter[];

    constructor(jsonObj:any){
        this.id=jsonObj.id;
        this.label=jsonObj.label;
        this.parameters=[];
        for (let p of jsonObj.parameters){
            this.parameters.push(new Parameter(p));
        }
    }
}

export class Parameter{
    label!:string;
    hint?:string;
    name!:string;
    canCustomerOverride?:boolean;
    canConfigurationOverride?:boolean;
    inputType!:string; //possible values are: slt=single line text, mlt=multi line text, sel=selection, msel=multi-select, num=numeric, eml=email, opt=option
    inputOptions?:string;
    mandatory!:boolean;
    secret?:boolean;
    ownerSecret?:boolean;
    defaultValue!: any;
    inputOptionArray?:any[];
    limitedToConfigLevels?:number[];
    keySource?:string; //on;y in the context of inputType 'kvplist'; right now we only use 'fd' for file definition fields

    constructor(jsonObj:any){
        Object.assign(this,jsonObj);
        if(this.inputOptions){
            this.inputOptionArray = JSON.parse(this.inputOptions);
        }
    }
}